import { render, staticRenderFns } from "./GoodsPriceList.vue?vue&type=template&id=35abfa1e&scoped=true&"
import script from "./GoodsPriceList.vue?vue&type=script&lang=js&"
export * from "./GoodsPriceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35abfa1e",
  null
  
)

export default component.exports